import React from 'react';
import classnames from 'classnames';

import { useTheme } from 'react-jss';

import { Icon } from '@sm/wds-react';
import { WrenchTheme } from '@wds/styles';

import { LogoProps } from './typings';
import useStyles from './useStyles';
import { WebAssetsThemeWrapper } from '../../theme';

const Logo = (props: LogoProps) => (
  <WebAssetsThemeWrapper>
    <LogoContent {...props} />
  </WebAssetsThemeWrapper>
);

const LogoContent = ({
  color = 'primary',
  className = '',
  ...other
}: LogoProps) => {
  const theme: typeof WrenchTheme = useTheme();

  const { logo } = useStyles({ color, theme });
  return (
    <Icon className={classnames(logo, className)} {...other}>
      ÷
    </Icon>
  );
};

export default Logo;
